// extracted by mini-css-extract-plugin
export default {"categoryLabel":"Q_c4H","breadcrumbs":"FQAxh"};